import API from '../config/api';
import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';

import { Container, Row, Col, Card, Badge, Button, Spinner } from 'react-bootstrap';

import CustomNavbar from '../components/CustomNavbar';

import { confirmToast } from '../utils/toast';
function AdminDeliveryPartnersPage() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPartners = async () => {
    try {
      const { data } = await axios.get(`${API}/partners`);
      setPartners(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  const setApproval = async (id, isApproved) => {
    try {
      await axios.put(`${API}/partners/${id}/approval`, { isApproved });
      toast.success(isApproved ? 'Partner approved' : 'Approval revoked');
      fetchPartners();
    } catch (error) {
      toast.error('Update failed');
    }
  };

  const removePartner = async (id) => {
    if (!(await confirmToast('Remove this delivery partner?'))) return;
    try {
      await axios.delete(`${API}/partners/${id}`);
      toast.success('Partner removed');
      fetchPartners();
    } catch (error) {
      toast.error('Delete failed');
    }
  };

  const pending = partners.filter((p) => !p.isApproved);
  const approved = partners.filter((p) => p.isApproved);

  if (loading) {
    return (
      <>
        <CustomNavbar />
        <Container className="text-center py-5">
          <Spinner animation="border" />
        </Container>
      </>
    );
  }

  const renderCard = (p) => (
    <Col lg={4} md={6} key={p._id}>
      <Card className="border-0 shadow-sm h-100 adp-card">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div className="d-flex align-items-center gap-2">
              <span className="adp-avatar">
                {p.name?.charAt(0).toUpperCase() || '?'}
              </span>
              <div>
                <div className="fw-bold">{p.name}</div>
                <small className="text-muted">
                  🛺 {p.vehicleType || 'N/A'}
                </small>
              </div>
            </div>
            <Badge
              bg={p.isApproved ? 'success' : 'warning'}
              className="rounded-pill"
            >
              {p.isApproved ? 'Approved' : 'Pending'}
            </Badge>
          </div>

          <div className="small mb-1">✉️ {p.email}</div>
          <div className="small mb-3">📞 {p.phone}</div>

          <div className="d-flex gap-2">
            {p.isApproved ? (
              <Button
                size="sm"
                variant="outline-warning"
                className="flex-fill fw-semibold"
                onClick={() => setApproval(p._id, false)}
              >
                Revoke
              </Button>
            ) : (
              <Button
                size="sm"
                variant="success"
                className="flex-fill fw-semibold"
                onClick={() => setApproval(p._id, true)}
              >
                ✓ Approve
              </Button>
            )}
            <Button
              size="sm"
              variant="outline-danger"
              className="fw-semibold"
              onClick={() => removePartner(p._id)}
            >
              🗑
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );

  return (
    <>
      <CustomNavbar />

      <div className="adp-wrap">
        <Container>
          <Card className="border-0 shadow-lg mb-4 adp-hero">
            <Card.Body className="p-4 p-md-5 d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <h1 className="fw-bold mb-1">🛵 Delivery Partners</h1>
                <p className="mb-0 adp-hero-text">
                  Approve and manage your delivery fleet
                </p>
              </div>
              <div className="d-flex gap-2">
                <Badge className="adp-count-badge">
                  {pending.length} Pending
                </Badge>
                <Badge className="adp-count-badge">
                  {approved.length} Active
                </Badge>
              </div>
            </Card.Body>
          </Card>

          {partners.length === 0 ? (
            <Card className="border-0 shadow-sm text-center py-5">
              <Card.Body>
                <div style={{ fontSize: '3rem' }}>🛵</div>
                <h5 className="fw-bold mt-2">No Delivery Partners Yet</h5>
                <p className="text-muted mb-0">
                  Partners who register will appear here for approval.
                </p>
              </Card.Body>
            </Card>
          ) : (
            <>
              {pending.length > 0 && (
                <>
                  <h5 className="fw-bold mb-3">⏳ Pending Approval</h5>
                  <Row className="g-4 mb-4">{pending.map(renderCard)}</Row>
                </>
              )}

              <h5 className="fw-bold mb-3">✅ Active Partners</h5>
              {approved.length === 0 ? (
                <p className="text-muted">No approved partners yet.</p>
              ) : (
                <Row className="g-4">{approved.map(renderCard)}</Row>
              )}
            </>
          )}
        </Container>
      </div>

      <style>{adpStyles}</style>
    </>
  );
}

const adpStyles = `
  .adp-wrap {
    background: radial-gradient(720px 320px at 8% -5%, rgba(124,58,237,0.12), transparent 70%), radial-gradient(720px 320px at 92% 105%, rgba(234,88,12,0.14), transparent 70%), linear-gradient(180deg, #faf5ff 0%, #fff7ed 55%, #fef3c7 100%);
    min-height: 100vh;
    padding: clamp(24px, 4vw, 44px) 0;
  }
  .adp-hero {
    border-radius: 22px;
    color: #fff;
    background: linear-gradient(120deg, #0f172a, #7c2d12 60%, #ea580c);
  }
  .adp-hero-text { opacity: 0.9; }
  .adp-count-badge {
    background: rgba(255,255,255,0.18) !important;
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 30px;
    padding: 10px 16px;
    font-weight: 600;
  }
  .adp-card { border-radius: 16px; transition: transform 0.2s ease; }
  .adp-card:hover { transform: translateY(-5px); box-shadow: 0 20px 36px rgba(194,65,12,0.15) !important; }
  .adp-avatar {
    width: 44px; height: 44px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%; color: #fff; font-weight: 700;
    background: linear-gradient(135deg, #ea580c, #f59e0b);
  }
`;

export default AdminDeliveryPartnersPage;
